<template>
  <div class="margin-bottom">
    <el-table :data="pagingList"
              v-loading="loadingStatus"
              :header-cell-style="headerCellStyle"
              :span-method="spanMethod"
              class="custom-delivery-table"
              max-height="600px"
              size="mini"
              border>
      <el-table-column label="起运城市"
                       v-if="!isDeliveryType"
                       width="90"
                       fixed
                       align="center">
        <template slot-scope="scope">
          {{ joinCityNameText(scope.row.cityList) ||"-" }}
        </template>
      </el-table-column>
      <el-table-column label="分区"
                       width="90"
                       fixed
                       align="center">
        <template slot-scope="scope">
          {{ scope.row.regionName||"-" }}
          <template v-if="scope.row.regionDetailList && scope.row.regionDetailList.length">
            ({{ joinRegionDetailText(scope.row.regionDetailList)}})
          </template>
        </template>
      </el-table-column>
      <el-table-column label="拆柜城市"
                       v-if="!isSegment || type === 1"
                       width="90"
                       fixed
                       align="center">
        <template slot-scope="scope">
          {{ scope.row.dismantlingCityName || scope.row.dismantlingCityId || "-" }}
        </template>
      </el-table-column>
      <el-table-column label="货物类型"
                       v-if="!isDeliveryType"
                       width="90"
                       fixed
                       align="center">
        <template slot-scope="scope">
          <template v-if="scope.row.goodsTypeList">
            <el-tooltip placement="top">
              <div slot="content" style="max-width: 800px;">{{ joinGoodsTypeText(scope.row.goodsTypeList) }}</div>
              <span style="text-overflow: ellipsis;-webkit-line-clamp: 3;-webkit-box-orient: vertical;display: -webkit-box;">
                {{ joinGoodsTypeText(scope.row.goodsTypeList) }}
              </span>
            </el-tooltip>
          </template>
        </template>
      </el-table-column>
      <template v-if="tableHeaderList.length">
        <template v-for="(item,index) in tableHeaderList">
          <el-table-column
            :label="joinLabelText(item,index)"
            :key="index"
            min-width="100"
            align="center"
          >
            <template slot-scope="scope">
              <template v-if="scope.row.priceList && scope.row.priceList.length > index">
                <custom-price-column
                  :price-item="scope.row.priceList[index]"
                  :is-need-inquiry="scope.row.isNeedInquiry"
                  :exemption-type="scope.row.exemptionType"
                  :open-custom="showOrdinaryPrice ? true : openCustom"
                  :copy-vip-price="showOrdinaryPrice"
                  is-detail
                />
              </template>
            </template>
          </el-table-column>
        </template>
      </template>
      <el-table-column
        v-if="isShowRatioSetting"
        :label="tableHeaderList.length ? tableHeaderList[0].chargeType === 'KG' ? '体积重比率' : '体重比' : '体积重比率'"
        :prop="tableHeaderList.length ? tableHeaderList[0].chargeType === 'KG' ? 'volumeWeightRatio' : 'weightVolumeRatio' : 'volumeWeightRatio'"
        width="120"
        align="center">
      </el-table-column>
      <template v-if="!isSegment && type === 1">
        <el-table-column label="提取时效"
                         width="100"
                         align="center">
          <template slot-scope="scope">
            {{scope.row.extractionAgingFrom}}~{{scope.row.extractionAgingTo}}{{timeTypeListMapObject[scope.row.extractionAgingUnit]}}
          </template>
        </el-table-column>
      </template>
      <el-table-column :label="deliveryAgingLabel"
                       width="100"
                       align="center">
        <template slot-scope="scope">
          {{scope.row.agingFrom}}~{{scope.row.agingTo}}{{timeTypeListMapObject[scope.row.agingUnit]}}
        </template>
      </el-table-column>
      <el-table-column label="专线api对接渠道代码"
                       v-if="isSupportMultiChannel"
                       width="90"
                       align="center">
        <template slot-scope="scope">
          {{ scope.row.channelCode||"-" }}
        </template>
      </el-table-column>
      <el-table-column label="备注"
                       width="150"
                       align="center">
        <template slot-scope="scope">
          {{ scope.row.remark || "-" }}
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      v-if="list && list.length>pageSize"
      class="paging-row"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="pageSizes"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalListNum"
    >
    </el-pagination>
  </div>
</template>

<script>
import {isArray, isObject} from "my-tools-kit";
import {rulesNotEmpty} from "@/assets/js/formRules";
import CustomPriceColumn
  from "@/components/QuotationManagement/components-productQuotation/cityCustomQuotationList/customPriceColumn";
import {mergeTableSpanMethod} from "@/components/QuotationManagement/components-productQuotation/cityCustomQuotationList/utils";
import {mapFromArrayToObject} from "@/assets/js/utils";

let headerCellStyle = { background: '#F9F9F9', color: '#141414', 'font-size': '15px', 'font-weight': '500' };
let timeTypeArray = [
  {label:'工作日',value:1},
  {label:'自然日',value:2},
];
export default {
  name: "viewCityCustomQuotationList",
  components: {CustomPriceColumn},
  props:{
    isSegment:Boolean,//是否是分段报价
    type:{ // 分段类型 1：全包(头程) 2:派送
      type:Number,
      default:1,
    },
    list:{
      type:Array,
      required:true,
      default:()=>[],
    },
    tableHeaderList:{
      type:Array,
      default:()=>[],
    },
    openCustom:Boolean,
    loadingStatus:Boolean,
    disabledEdit:Boolean,
    openSetFreeDelivery:Boolean,//开放"设为免派区域"
    isSupportMultiChannel:Boolean,//是否多渠道
    // 是否显示分区设置计费转换系数
    isShowRatioSetting: {
      type: Boolean,
      default: false
    },
    showOrdinaryPrice: {
      type: Boolean,
      default: false
    }
  },
  data(){
    return {
      headerCellStyle,
      /* 分页参数 */
      pageSizes: [10,20,30,40,50],
      pageSize: 10,
      currentPage: 1,

      /*弹窗：设置时间*/
      timeTypeList:timeTypeArray,
      timeTypeListMapObject:mapFromArrayToObject(timeTypeArray),
    }
  },
  computed:{
    isDeliveryType(){
      return this.type === 2
    },
    pagingList(){
      let list = this.list;
      if(!isArray(list) || !list.length) return [];
      let start = this.pageSize * (this.currentPage - 1);
      let end = this.pageSize * this.currentPage;
      return list.slice(start,end);
    },
    totalListNum(){
      let list = this.list||[];
      return list.length
    },
    deliveryAgingLabel(){
      return this.type === 2 ? "派送时效" : "整体时效";
    },
  },
  watch:{
    list(){
      this.handleCurrentChange();
    },
  },
  methods:{
    /**
     * pageSize 改变时会触发：选择每页显示条数
     */
    handleSizeChange(val, type) {
      this.pageSize = val;
      this.handleCurrentChange();
    },
    /**
     * currentPage 改变时会触发：选择页数
     */
    handleCurrentChange(val = 1, type) {
      this.currentPage = val;
    },
    /**
     * 拼接文本
     * @param item  tableHeaderList Item
     * @param index
     * @returns {string}
     */
    joinLabelText(item = {},index){
      if(!isObject(item)) return "";
      let chargeType = item.chargeType||"";
      if(chargeType.toUpperCase() === "BOX") chargeType = "箱";
      else if(chargeType.toUpperCase() === "PK") chargeType = "车";
      let str = ""
      if(item.end){
        str = `${item.start}-${item.end}${chargeType}`
      }else{
        str = `${item.start}${chargeType}以上`
      }
      if(item.supportRenewal){
        if(index === 0){
          str = "首重" + str;
        }else if(index === 1){
          str = "续重" + str;
        }
      }
      return str;
    },
    /**
     * 合并行或列的计算方法
     */
    spanMethod:mergeTableSpanMethod,

    /**
     * 拼接可走货物类型文本
     * @param list
     * @returns {string}
     */
    joinGoodsTypeText(list = []){
      return list.map(item=>item.goodsTypeName).join(",");
    },
    joinCityNameText(list = []){
      return list.map(item=>item.cityName).join(",");
    },
    joinRegionDetailText(list = []){
      return list.map(item=>item.namec).join(",");
    },
  },
}
</script>

<style scoped lang="scss">
.custom-delivery-table{
  &.el-table /deep/ {
    td{
      position: relative;
      //padding: 0;
      .cell {
        text-align: center;
        font-size: 15px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #141414;
      }
    }
  }
  /deep/ .custom-input-number{
    width: 100px;
    .custom-input-number__decrease,
    .custom-input-number__increase{
      width: 18px;
    }
    .custom-input-number__decrease{}
    .custom-input-number__increase{}
    .el-input__inner{
      padding-left: 20px ;
      padding-right: 20px ;
    }
  }
  .unit{
    font-size: 12px;
    color: #999;
  }
  .error-hint{
    color: red;
    font-size: 12px;
    line-height: 1;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    text-align: center;
  }
  .is-private-address{
    font-size: 12px;
    color: #f56c6c;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/QuotationManagement/components-productQuotation/viewDetails/viewCityCustomQuotationList.vue